import React from 'react';

import { WarningCard } from '@eika/card';
import { Link, LinkType } from '@eika/link';

import { useConfig } from '../../defaultConfig';
import useTranslation from '../../hooks/useTranslation';

interface Props {
    title?: string;
}

const AccountsEmptyInfo: React.FC<Props> = ({ title }) => {
    const { createAccountsLink, featureToggles } = useConfig();
    const translated = useTranslation();
    return (
        <WarningCard isModal title={title ?? translated.accountsEmptyInfo.title}>
            {createAccountsLink && !featureToggles.disableAccountCreation && (
                <Link
                    linkType={LinkType.BUTTON_SMALL_POSITIVE}
                    href={createAccountsLink?.url}
                    style={{ marginTop: '24px' }}
                >
                    {translated.accountsList.createAccount}
                </Link>
            )}
        </WarningCard>
    );
};

export default AccountsEmptyInfo;
